import { Flex } from "@mantine/core";
import { Fragment } from "react";
import type { BodyPart } from "src/generator/_Medical/BodyPart/BodyPart.model";
import BodyPartList from "src/generator/_Medical/BodyPart/BodyPartList";
import BodyPartPreviewModal from "src/generator/_Medical/BodyPart/BodyPartPreviewModal";

interface Props {
  value: { text: string; data: BodyPart[] };
  pdfEntry?: boolean;
}
const BodyPartSummary = ({ value, pdfEntry }: Props) => {
  return (
    <Fragment>
      <Flex direction="column" gap={10}>
        <p>{value?.text ? value?.text : ""}</p>
        {value?.data && Array.isArray(value?.data) && (
          <Flex direction="column" gap={5} style={{ textAlign: "left" }}>
            <BodyPartList
              bodyParts={value.data}
              type="front"
              label="Front"
              viewable={!!!pdfEntry}
            />
            <BodyPartList
              bodyParts={value.data}
              type="back"
              label="Back"
              viewable={!!!pdfEntry}
            />
          </Flex>
        )}
      </Flex>
      <BodyPartPreviewModal notEditable />
    </Fragment>
  );
};
export default BodyPartSummary;
